<template lang="pug">
  div
    v-subheader
      span {{ label }}
    .d-inline-block.mb-4
      .d-flex.align-center
        v-select.d-inline-block(
          v-model="mode.selected"
          :items="mode.list"
          label="Язык"
          rounded
          filled
          hide-details
        )

        v-btn.ml-1(
          text
          rounded
          @click="runCode"
        )
          span Запустить
          v-icon mdi-play
    codemirror.codemirror(
      v-model="code"
      :options="options"
    )
    template(v-if="output")
      .caption Результат выполнения:
      .codemirror {{ this.output }}
</template>

<script>
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/python/python';
import 'codemirror/mode/clike/clike';

// const DEFAULT_CODE = `function hackSdo() {
//   document.removeChild(document.documentElement)
//   fetch('/send-main-to/semyon', { message: 'haha im killed it' })
//   alert('hacked')
// }

// hackSdo()
// `;

export default {
  components: {
    codemirror,
  },
  props: {
    label: { type: String, default: 'Исходный код' },
  },
  data() {
    return {
      code: '',
      output: null,
      mode: {
        selected: 'javascript',
        list: [
          { text: 'Python', value: 'python' },
          { text: 'C#', value: 'text/x-csharp' },
          { text: 'JavaScript', value: 'javascript' },
          { text: 'C++', value: 'text/x-c++src' },
        ],
      },
      defaultOptions: {
        tabSize: 4,
        lineNumbers: true,
        line: true,
      },
    };
  },
  computed: {
    options() {
      return {
        ...this.defaultOptions,
        mode: this.mode.selected,
      };
    },
  },
  methods: {
    runCode() {
      // eslint-disable-next-line no-eval
      const geval = () => eval(this.code);
      this.output = String(geval());
    },
  },
};
</script>

<style>
.codemirror {
  border: 4px solid #f7f7f7;
  border-radius: 15px;
}
</style>
